import type { AddColorProps } from "./ColorPicker.types";

export const AddColor = ({ onSave }: AddColorProps) => {
  return (
    <div className="flex w-full flex-row items-center justify-between py-1 text-xs font-medium text-[#374151]">
      <p>Saved colors: </p>
      <button onClick={onSave}>+ Add</button>
    </div>
  );
};
